module.exports = __webpack_public_path__ + "fonts/ubuntu-v20-latin_cyrillic-italic.ttf";